import { flattenDeep, sortBy } from 'lodash';
export function organizeAccounts(accounts) {
    const groupedAccounts = groupParentAndChildrenAccounts(accounts);
    const sortedAccounts = [];
    groupedAccounts.forEach((account) => {
        sortedAccounts.push(account.parent);
        if (account.children.length > 0) {
            sortedAccounts.push(...sortBy(account.children, [(child) => child.normalizedName]));
        }
    });
    return flattenDeep(sortedAccounts);
}
function groupParentAndChildrenAccounts(accounts) {
    const result = new Map();
    accounts.forEach((account) => {
        var _a;
        if (account.parentAccount) {
            if (result.has(account.parentAccount.id.toString())) {
                (_a = result.get(account.parentAccount.id.toString())) === null || _a === void 0 ? void 0 : _a.children.push(account);
            }
            else {
                result.set(account.parentAccount.id.toString(), {
                    parent: {},
                    children: [account],
                });
            }
        }
        else {
            if (result.has(account.id.toString())) {
                result.get(account.id.toString()).parent = account;
            }
            else {
                result.set(account.id.toString(), {
                    parent: account,
                    children: [],
                });
            }
        }
    });
    return result;
}
//# sourceMappingURL=organizeAccounts.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
